import './App.css';
import Router from './pages/router/Router';

function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
